'use client'
import { signIn, useSession } from 'next-auth/react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import LoadingWithOutMessage from '../loading/LoadingWithoutMessage'

export default function Login() {
    const { data: session, status } = useSession()
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const router = useRouter()

    const [tryAgain, setTryAgain] = useState(true)

    useEffect(() => {
        const callbackUrl = searchParams?.get('callbackUrl')
    
        if (tryAgain && window && (!session || status == 'unauthenticated')) {
            const ua = navigator.userAgent
            const isChromeOrEdge = /CriOS|EdgiOS/i.test(ua)

            if (isChromeOrEdge) {
                router.push('/mobile-browser-error')
            } else {
                /**
                 * without the callbackUrl param, the default behaviour is redirect to the page URL the sign-in is initiated from.
                 * https://next-auth.js.org/getting-started/client#specifying-a-callbackurl
                 *
                 * when user direct access the "/login" path, then redirect after sucessfull login to index page
                 */
                const signInOptions =
                    pathname == '/api/auth/signin'
                        ? { callbackUrl: callbackUrl ? window.location.origin + callbackUrl : '/' }
                        : {}
                signIn('dbwebsso', signInOptions)
                    .then(() => {})
                    .catch((error: any) => {
                        console.error('Error during sign-in:', error)
                        console.log(error)
                        setTryAgain(false)
                    })
            }
        }
    }, [status])

    return (
        <div className="h-dvh flex flex-col items-center justify-center gap-1">
            <h1>Login</h1>
            <LoadingWithOutMessage />
        </div>
    )
}
